import * as React from "react";
import { UitkCard, UitkCardPlaceholder } from "uitk-react-cards";
import { Viewport, ViewSmall, ViewMedium, ViewLarge } from "bernie-view";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

import { viewportConfigs, ViewportSizes } from "../typings";

const placeHolderCardsToDisplay = [1, 2];

const renderPlaceholdersByView = ({ viewport = ViewportSizes.SMALL }: { viewport?: ViewportSizes }) => {
  const { wrap, minWidth } = viewportConfigs[viewport];

  return (
    <UitkLayoutFlex className="TripAttachQualification all-t-padding-four all-b-padding-six" space="two" wrap={wrap}>
      {placeHolderCardsToDisplay.map((num) => (
        <UitkLayoutFlexItem minWidth={minWidth} grow={1} key={num}>
          <div>
            <UitkCard>
              <Viewport>
                <ViewSmall>
                  <UitkCardPlaceholder className="ratio-3-1 uitk-card-roundcorner-all" />
                </ViewSmall>
                <ViewMedium>
                  <UitkCardPlaceholder className="uitk-card-roundcorner-all" />
                </ViewMedium>
                <ViewLarge>
                  <UitkCardPlaceholder className="ratio-3-1 uitk-card-roundcorner-all" />
                </ViewLarge>
              </Viewport>
            </UitkCard>
          </div>
        </UitkLayoutFlexItem>
      ))}
    </UitkLayoutFlex>
  );
};

export const TripAttachLoadingView = () => (
  <Viewport>
    <ViewSmall>{renderPlaceholdersByView({})}</ViewSmall>
    <ViewLarge>{renderPlaceholdersByView({ viewport: ViewportSizes.LARGE })}</ViewLarge>
  </Viewport>
);

export default TripAttachLoadingView;
